import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "flex flex-row items-center justify-between" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = {
  key: 1,
  class: "capitalize"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  class: "h-5 w-5",
  viewBox: "0 0 20 20",
  fill: "currentColor"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    d: "M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z",
    "clip-rule": "evenodd"
  })
], -1)
const _hoisted_5 = {
  key: 0,
  ref: "dropdown",
  class: "absolute flex flex-col rounded-2xl shadow bg-white mt-8 w-full z-50"
}
const _hoisted_6 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(`relative flex flex-col w-${_ctx.width}`)
  }, [
    _createElementVNode("button", {
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showDropdown = true))
    }, [
      _createElementVNode("div", _hoisted_1, [
        (!_ctx.selected || _ctx.selection === 'all')
          ? (_openBlock(), _createElementBlock("span", _hoisted_2, "Filter by " + _toDisplayString(_ctx.name), 1))
          : (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_ctx.selection.replaceAll("_", " ")), 1)),
        _hoisted_4
      ])
    ]),
    (_ctx.showDropdown)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createElementVNode("button", {
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.selection = 'all')),
            class: "py-4 rounded hover:bg-background-secondary"
          }, " All "),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, (option, i) => {
            return (_openBlock(), _createElementBlock("button", {
              key: i,
              class: "py-4 capitalize rounded-2xl hover:bg-background-secondary",
              onClick: ($event: any) => (_ctx.selection = option)
            }, _toDisplayString(option.replaceAll("_", " ")), 9, _hoisted_6))
          }), 128))
        ], 512))
      : _createCommentVNode("", true)
  ], 2))
}